import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/textAd';
import editorTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/textAd.pug';
import previewBuilder from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/textAd';
import UpgradedUrl from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/upgradedUrl';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import uuid from '@bingads-webui-component-legacy/uuid/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const placeholders = {
  Text: i18n.get('Ad_Placeholder_Text'),
  Title: i18n.get('Ad_Placeholder_Title'),
  DisplayUrl: i18n.get('Ad_Placeholder_DisplayUrl'),
  DestinationUrl: i18n.get('Ad_Placeholder_DestinationUrl'),
};

export default class TextAdEditor extends Backbone.View {
  initialize({
    showAdType = false,
    isNativeAdsEnabled = false,
    model = null,
    showInline = false,
    editMode = false,
    isTraditionalChinese = false,
    defaultLandingPageUrl = '',
  } = {}) {
    this.showAdType = showAdType;
    this.isNativeAdsEnabled = isNativeAdsEnabled;
    this.model = model;
    this.showInline = showInline;
    this.editMode = editMode;
    this.defaultLandingPageUrl = defaultLandingPageUrl;

    this.viewModel = new ViewModel({
      model,
      isNativeAdsEnabled,
      isTraditionalChinese,
    });
  }

  get events() {
    return {
      'click .prefer-native-format': 'preferNativeAdFormat',
      'click .prefer-mobile-device': 'devicePreferenceChanged',
    };
  }

  render() {
    this.$el.html(editorTemplate({
      i18n,
      uuid,
      isNativeAdsEnabled: this.isNativeAdsEnabled,
      placeholders,
      showAdType: this.showAdType,
    }));

    ko.applyBindings(this.viewModel, this.el);

    this.upgradedUrlView = new UpgradedUrl({
      model: this.model,
      adViewModel: this.viewModel,
      api: this.showInline ? 'odata' : 'bulk',
      editMode: this.editMode,
      urlOptionsEnabled: this.showInline,
      defaultLandingPageUrl: this.defaultLandingPageUrl,
      ariaPrefix: 'textAd',
    });

    this.$('.upgraded-url').empty().append(this.upgradedUrlView.render().el);

    this.previewContainer = previewBuilder.buildPreview(this.viewModel);
    this.$('.preview-container').empty().append(this.previewContainer.render().el);
    this.previewContainer.selectedPanel(this.viewModel.initPreviewTab());

    return this;
  }

  resetEditMode(mode) {
    this.upgradedUrlView.editMode = mode;
  }

  preferNativeAdFormat() {
    let type = 'top';

    if (this.viewModel.showNativeAdPreview()) {
      type = 'native';
    } else if (this.viewModel.DevicePreference.isMobile()) {
      type = 'mobile';
    }

    this.previewContainer.selectedPanel(type);
  }

  devicePreferenceChanged(event) {
    if (!this.viewModel.showNativeAdPreview()) {
      if (this.viewModel.DevicePreference.isMobile()) {
        this.previewContainer.selectedPanel('mobile');
      } else {
        this.previewContainer.selectedPanel('top');
      }
    }

    this.upgradedUrlView.devicePreferenceChanged(event);
  }

  validate() {
    const upgradedUrlValid = this.upgradedUrlView.validate();

    return this.viewModel.validate() && upgradedUrlValid;
  }

  toObject() {
    const model = this.viewModel.toObject();

    return _.extend(_.omit(model, this.viewModel.upgradedUrlFields), this.upgradedUrlView.toObject());
  }

  handleApiErrors(errors) {
    _.each(errors, (error) => {
      if (_.result(error, 'property') === 'DestinationUrl') {
        error.property = 'FinalUrls';
      }
    });
    this.viewModel.errors.add(errors);

    if (!_.isEmpty(errors)) {
      this.upgradedUrlView.handleApiErrors();
    }
  }

  clearApiErrors() {
    this.viewModel.errors.clear(isCampaignApiError);
    this.upgradedUrlView.clearApiErrors();
  }
}
